export var CustomPDFReportCreateOption;
(function (CustomPDFReportCreateOption) {
    CustomPDFReportCreateOption["BLANK_REPORT"] = "blank_report";
    CustomPDFReportCreateOption["NEW_FROM_TEMPLATE"] = "new_from_template";
})(CustomPDFReportCreateOption || (CustomPDFReportCreateOption = {}));
export var CustomPDFReportSaveOption;
(function (CustomPDFReportSaveOption) {
    CustomPDFReportSaveOption["SAVE"] = "save";
    CustomPDFReportSaveOption["SAVE_AS"] = "save_as";
})(CustomPDFReportSaveOption || (CustomPDFReportSaveOption = {}));
export var CustomPDFReportTabDropdownOption;
(function (CustomPDFReportTabDropdownOption) {
    CustomPDFReportTabDropdownOption["NEW_FROM_TEMPLATE"] = "newFromTemplateReport";
    CustomPDFReportTabDropdownOption["OPEN"] = "openReport";
    CustomPDFReportTabDropdownOption["REPORT_SETTINGS"] = "openReportSettings";
    CustomPDFReportTabDropdownOption["DUPLICATE"] = "duplicateReport";
    CustomPDFReportTabDropdownOption["REMOVE"] = "removeReport";
    CustomPDFReportTabDropdownOption["DELETE"] = "deleteReport";
})(CustomPDFReportTabDropdownOption || (CustomPDFReportTabDropdownOption = {}));
